import React, { useContext } from 'react'
import { AllStarContext } from '../../../../Context'
import { Rosters } from './Rosters/Rosters'
import { BoxscoreStyle } from './styles'
import { ASGTabBackground } from '../../styles'
import { SpinnerCon } from '../../../FreeAgency/styles'
import { Spinner } from '../../../../Components/Icons'
import { colors } from '../../../../Components/consts'

export const GameCon: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { loading, allStarEvent } = useContext(AllStarContext)!

  const renderSpinner = () => {
    return (
      <SpinnerCon>
        <div>
          <Spinner fill={colors.yellow} />
          Loading...
        </div>
      </SpinnerCon>
    )
  }

  return (
    <>
      {loading && renderSpinner()}
      {!loading && allStarEvent && (
        <ASGTabBackground>
          <BoxscoreStyle>
            <Rosters />
          </BoxscoreStyle>
        </ASGTabBackground>
      )}
    </>
  )
}
